import { useMemo } from 'react';
import { isAdminSite } from '~/utils';
import { getNavigationConfig } from '../config';

/**
 * Custom hook that provides the appropriate navigation config based on user type
 * Uses dependency injection pattern and isAdminSite() utility function
 */
export const useNavigationConfig = () => {
  const isAdmin = !!isAdminSite();

  const navigationConfig = useMemo(() => getNavigationConfig(isAdmin), [isAdmin]);

  return {
    navigationConfig,
    isAdmin,
  };
};
